import { datadogRum } from '@datadog/browser-rum'

import { DD_RUM_ENABLED_FLAG } from '@src/config/env'

export const isRumActive = (): boolean => typeof window !== 'undefined' && DD_RUM_ENABLED_FLAG

export const setRumGlobalContext = (context: Record<string, string | undefined>): void => {
  if (!isRumActive()) return
  try {
    Object.entries(context).forEach(([key, value]) => {
      if (value) datadogRum.setGlobalContextProperty(key, value)
    })
  } catch {
    // Intentionally swallowed: RUM must never affect page correctness.
  }
}

export const removeRumGlobalContext = (keys: string[]): void => {
  if (!isRumActive()) return
  try {
    keys.forEach(key => {
      datadogRum.removeGlobalContextProperty(key)
    })
  } catch {
    // Intentionally swallowed: RUM must never affect page correctness.
  }
}

export const trackRumAction = (name: string, ctx: Record<string, unknown> = {}): void => {
  if (!isRumActive()) return
  try {
    datadogRum.addAction(name, ctx)
  } catch {
    // Intentionally swallowed: RUM must never affect page correctness.
  }
}

export const captureRumError = (error: unknown, context: Record<string, unknown> = {}): void => {
  if (!isRumActive()) return
  try {
    datadogRum.addError(error, context)
  } catch {
    // Intentionally swallowed: RUM must never affect page correctness.
  }
}

export const setRumViewContext = (key: string, value: string): void => {
  if (!isRumActive()) return
  try {
    datadogRum.setViewContextProperty(key, value)
  } catch {
    // Intentionally swallowed: RUM must never affect page correctness.
  }
}
